window.addEventListener('resize', function(event){
  findVisibleItems();
  initProductSlider();
  initProductThumbSlider();
});

function initProductSlider(section = document){
  let sliderMain = section.querySelector('[data-flickity-product-slider]');
  if(sliderMain){
    let optionContainer = sliderMain.getAttribute('data-flickity-product-slider');
    if(optionContainer){
      var options = JSON.parse(optionContainer);
      if(sliderMain.hasAttribute("data-mobile-only")){
        if($(window).width() < 768 ){
          if (!sliderMain.classList.contains('flickity-enabled')) {
             productSlider =new Flickity(sliderMain,options);
            setTimeout(function(){
              productSlider.resize();
            },300)
          }
        }
        else{
          if (sliderMain.classList.contains('flickity-enabled')) {
            productSlider.destroy();
          }
        }
      }      
      else if(sliderMain.hasAttribute("data-desktop-only")){
        if($(window).width() >= 768 ){
          if (!sliderMain.classList.contains('flickity-enabled')) {
              productSlider =new Flickity(sliderMain,options);
              setTimeout(function(){
                productSlider.resize();
              },300)
          }
        }
        else{
          if (sliderMain.classList.contains('flickity-enabled')) {
            productSlider.destroy();
          }
        }
      }
      else{
        if (!sliderMain.classList.contains('flickity-enabled')) {
            productSlider =new Flickity(sliderMain,options);
            setTimeout(function(){
              productSlider.resize();
            },300)
        }
      }
      if(productSlider){
        productSlider.on( 'change', function( index ) {
          let sliderMain= productSlider.$element[0];
          sliderMain.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          });
          sliderMain.querySelectorAll('.yv-vimeo-video').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          });
          sliderMain.querySelectorAll('video').forEach((video) => video.pause() );
        });
      }
    }
  }
}

function initProductThumbSlider(section = document){
  let sliderMain = section.querySelector('[data-flickity-product-thumb-slider]');
  if(sliderMain){
    let optionContainer = sliderMain.getAttribute('data-flickity-product-thumb-slider');
    if(optionContainer){
      var options = JSON.parse(optionContainer);
      if(sliderMain.hasAttribute("data-mobile-only")){
        if($(window).width() < 768 ){
          if (!sliderMain.classList.contains('flickity-enabled')) {
           productThumbSlider =new Flickity(sliderMain,options);
          productThumbSlider.resize();
          }
        }
        else{
          if (sliderMain.classList.contains('flickity-enabled')) {
            productThumbSlider.destroy();
          }
        }
      }      
      else if(sliderMain.hasAttribute("data-desktop-only")){
        if($(window).width() >= 768 ){
          if (!sliderMain.classList.contains('flickity-enabled')) {
              productThumbSlider =new Flickity(sliderMain,options);
          productThumbSlider.resize();
          }
        }
        else{
          if (sliderMain.classList.contains('flickity-enabled')) {
            productThumbSlider.destroy();
          }
        }
      }
      else{
        if (!sliderMain.classList.contains('flickity-enabled')) {
            productThumbSlider =new Flickity(sliderMain,options);
          productThumbSlider.resize();
        }
      }
      if(productThumbSlider){
        productThumbSlider.on( 'change', function( index ) {
          let sliderMain= productThumbSlider.$element[0];
          sliderMain.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          });
          sliderMain.querySelectorAll('.yv-vimeo-video').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          });
          sliderMain.querySelectorAll('video').forEach((video) => video.pause() );
        });
      }
    }
  }
}

var productMediaModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: (function(){
          
          document.querySelectorAll('.yv-product-model-item').forEach((model) => {   
            let model3D = model.querySelector('model-viewer')
            model.modelViewerUI = new Shopify.ModelViewerUI(model3D);
            model3D.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
              model.querySelectorAll('.close-product-model').forEach(el => {
                el.classList.remove('hidden');
              });
              if(productSlider){
                productSlider.options.draggable = false;
                productSlider.updateDraggable();
              }
            }.bind(this));

            model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
              model.querySelectorAll('.close-product-model').forEach(el => {
                el.classList.add('hidden');
              });
              if(productSlider){
                productSlider.options.draggable = true;
                productSlider.updateDraggable();
              }
            }.bind(this));
			
            model.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', function() {
                if (model3D) {
                  model.modelViewerUI.pause();
                }
              }.bind(this))
            });
            
          });

        })
      }
    ]);
  },

  setupShopifyXR(errors) {
    if (!errors) {
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
                                  this.setupShopifyXR()
        );
        return;
      }
      document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
        window.ShopifyXR.addModels(JSON.parse(model.textContent));
      });
      window.ShopifyXR.setupXRElements();
    }
  },
};

window.addEventListener('DOMContentLoaded', () => {
  let productModel = document.querySelectorAll('[id^="product3DModel-"]');
  if (productMediaModel && productModel.length > 0 ){
    productMediaModel .loadShopifyXR();
  }
});

function findVisibleItems(){
  let mainSliderParent =  document.getElementById('yv-product-gallery-slider');
  if(mainSliderParent){
    var elements = mainSliderParent.getElementsByClassName('gallery-main-item');

    var thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');
    
    window.addEventListener('scroll', function(event){
      Array.from(elements).forEach(function(item) {
        if (isOnScreen(item)) {
          thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');
          
          var relatedThumb = mainSliderParent.querySelector('.gallery-thumbs-item[data-image="'+item.id+'"]');
          if(relatedThumb){
            Array.from(thumbs).forEach(function(thumb) {
              if(thumb != relatedThumb){
              thumb.classList.remove('active');
              }
            });
            if(!relatedThumb.classList.contains('active')){
              relatedThumb.classList.add('active'); 
            }
          }
        }
      });

    });
  }

  let mainTabsContent =  document.getElementById('yvProductFeatureListwrapper');
  if(mainTabsContent){
    // setTimeout(function(){
    //   let headerMain = document.getElementById('headerSection');
    //   let body = document.querySelector('body');
    //   let headerHeight = headerMain.offsetHeight+5;
    //   if(body.classList.contains('sticky-header')){
    //     mainTabsContent.style.top = headerHeight+'px';
    //   }
    //   else{
    //     mainTabsContent.style.top = '5px';    	
    //   }
    // },300);
    let contentTabs = document.getElementsByClassName('yv-product-feature');

	
    window.addEventListener('scroll', function(event){
     
      Array.from(contentTabs).forEach(function(item) {
        if (isOnScreen(item)) {
          let headTabs = document.getElementsByClassName('feature-link');
          Array.from(headTabs).forEach(function(head) {
            head.parentNode.classList.remove('active');
          });
          var relatedHead = document.querySelector('.feature-link[href="#'+item.id+'"]');
          if(relatedHead){
            relatedHead.parentNode.classList.add('active');
          }
        }
      });

    });
  }
}

function initStickyAddToCart(){
  let mainProductForm =  document.querySelector('.main-product-form[action^="'+cartAdd+'"]');
  if(mainProductForm){
    let stickyBar =  document.getElementById('yvProductStickyBar');
    if(stickyBar){
      window.addEventListener('scroll', function(event){
        if (isOnScreen(mainProductForm,true) || window.scrollY < mainProductForm.offsetTop) {
          stickyBar.classList.remove('show');
        }else{     
          stickyBar.classList.add('show');
        }
      });  	
    }
  }
}

function sizeChart(){
  var sizeChartInit = document.querySelectorAll('.sizeChart-label');
  if(sizeChartInit){
    var sizeChartModel = document.getElementById('sizeChartModel');
    if(sizeChartModel){
      var sizeChartClose = sizeChartModel.querySelector('#sizeChartClose');
      sizeChartInit.forEach(function (sizeChart) {
      sizeChart.addEventListener("click", (e)=>{ 
        e.preventDefault();             
        sizeChartModel.fadeIn(100);
        document.querySelector('body').classList.add('sizeChartOpen'); 
        focusElement = sizeChart;
        sizeChartClose.focus();
      });
      });
      sizeChartClose.addEventListener("click", ()=>{
        document.querySelector('body').classList.remove('sizeChartOpen');
        sizeChartModel.fadeOut(100);
        focusElement.focus();
        focusElement='';
    });
  }
}
}
// function ThzhotspotPosition(evt, el, hotspotsize, percent) {
//   var left = el.offset().left;
//   var top = el.offset().top;
//   var hotspot = hotspotsize ? hotspotsize : 0;
//   if (percent) {
//     x = (evt.pageX - left - (hotspot / 2)) / el.outerWidth() * 100 + '%';
//     y = (evt.pageY - top - (hotspot / 2)) / el.outerHeight() * 100 + '%';
//   } else {
//     x = (evt.pageX - left - (hotspot / 2));
//     y = (evt.pageY - top - (hotspot / 2));
//   }

//   return {
//     x: x,
//     y: y
//   };
// }

// function productZoomInit(){
//   $('[data-flickity-product-slider]').mouseenter(function(e){
//     $('.yv-product-zoom').removeClass('show');
    
//     var _target = e.target
//     if (!_target.classList.contains("yv-product-zoom")) {
//       return false;
//     }
//     var zoomElement = $(this).find('.yv-product-zoom');
//     if($(this).hasClass('flickity-enabled')){
//       zoomElement = $(this).find('.yv-product-image-item.is-selected').find('.yv-product-zoom');
//     }
//     if($(window).width() > 1021){
//       zoomElement.addClass('show');
//     }
//   })
//   $('[data-flickity-product-slider]').mousemove(function(e){
//     var zoomElement = $(this).find('.yv-product-zoom');
//     if($(this).hasClass('flickity-enabled')){
//       zoomElement = $(this).find('.yv-product-image-item.is-selected').find('.yv-product-zoom');
//     }
//     $('.yv-product-zoom').removeClass('show');
    
//     var _target = e.target
//     console.log('hp',_target,_target.classList.contains("yv-product-zoom"))
//     if (!_target.classList.contains("yv-product-zoom")) {
//       $('.yv-product-zoom').removeClass('show');
//       return false;
//     }
   
//     if($(window).width() > 1021){
//       zoomElement.addClass('show');
//       let hp = ThzhotspotPosition(e, zoomElement, 0, true); 
//       zoomElement.find('.gallery-cursor').css({
//         "top":hp.y,
//         "left":hp.x
//       });
//     }
//   })
//   $('[data-flickity-product-slider]').mouseleave(function(e){
//     $('.yv-product-zoom').removeClass('show');
//   })
// }

const getMousePos = (e) => {
  var pos = e.currentTarget.getBoundingClientRect();
  return {
    x: e.clientX - pos.left,
    y: e.clientY - pos.top,
  };
};
const zoomIconEl = document.querySelector('[zoom-icon]');
const zoomIcon = zoomIconEl ? zoomIconEl.getAttribute('zoom-icon') : null;
if(zoomIcon){
function productZoomInit(){
  $('.yv-product-zoom').mouseenter(function(e){
    $('.yv-product-zoom').removeClass('show');
    if($(window).width() > 1021){
      $(this).addClass('show');
    }
  })
  $('.yv-product-zoom').mousemove(function(e){
    if($(window).width() > 1021){
      let t = getMousePos(e);
      this.querySelector('.gallery-cursor').style.translate = `${t.x}px ${t.y}px`;
    }
  })
  $('.yv-product-zoom').mouseleave(function(e){
    $('.yv-product-zoom').removeClass('show');
  })
}
}
document.addEventListener("DOMContentLoaded", findVisibleItems,false);
document.addEventListener("shopify:section:load", findVisibleItems,false);

document.addEventListener("DOMContentLoaded", productZoomInit,false);
document.addEventListener("shopify:section:load", productZoomInit,false);

// Wrapped, not passed bare: both take `section = document` and call
// section.querySelector immediately, so a bare reference would receive the
// DOMContentLoaded Event as `section` and throw. The four registrations above
// take no arguments, which is why they can be passed directly.
document.addEventListener("DOMContentLoaded", function () { initProductSlider(); },false);
document.addEventListener("DOMContentLoaded", function () { initProductThumbSlider(); },false);

document.addEventListener("shopify:section:load",function (event) {
  initProductSlider(event.target)
  initProductThumbSlider(event.target);
});

document.addEventListener("DOMContentLoaded", sizeChart,false);
document.addEventListener("shopify:section:load", sizeChart,false);

document.addEventListener("DOMContentLoaded", initStickyAddToCart,false);
document.addEventListener("shopify:section:load", initStickyAddToCart,false);



$(document).ready(function(){
 setTimeout(function(){
    var thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
    var lastKnownY = window.scrollY;
    var currentTop = 0;
    if(thumbnails){
      var initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top);

      window.addEventListener('scroll', function(event){
        var  bounds = thumbnails.getBoundingClientRect(),
            maxTop = bounds.top + window.scrollY - thumbnails.offsetTop + initialTopOffset,
            minTop = thumbnails.clientHeight - window.innerHeight;

        if (window.scrollY < lastKnownY) {
          currentTop -= window.scrollY - lastKnownY;
        } else {
          currentTop += lastKnownY - window.scrollY;
        }
        currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset);
        lastKnownY = window.scrollY;
        thumbnails.style.top = "".concat(currentTop, "px");
      });
    }
  },1000)

  jQuery('body').on('click','.gallery-thumbs-item',function(e) {
    if (e.isTrigger) {
      // Programmatic click fired by the variant-change image sync in common.js;
      // the image swap already happened there, only a real user click should scroll the page.
      return;
    }
    e.preventDefault();
    var destination = jQuery(this).attr('data-image');
    var top = 10; 
  //  if(jQuery('#headerSection').hasClass('sticky-header')){
      top = jQuery('.shopify-section-main-header').height() + 10;
  //  }
    if(jQuery('#'+destination+'.gallery-main-item').length > 0){
      jQuery('html,body').animate({ scrollTop:(jQuery('#'+destination+'.gallery-main-item').offset().top) - top});
    }
  });


  jQuery('body').on('click','.pdp-view-close',function(e) {
    e.preventDefault();
    jQuery('#yvProductStickyBar').remove();    
  });
  jQuery('body').on('click','.feature-link',function(e) {
    e.preventDefault();

    let destination = jQuery(this).attr('href');
    let top = 10;
    // if(jQuery('#headerSection').hasClass('sticky-header')){
      top = jQuery('.shopify-section-main-header').height() + 90;
    // }
    if(jQuery(destination).length > 0){
      jQuery('html,body').animate({ scrollTop:(jQuery(destination).offset().top) - top});
    }
  });


  jQuery('body').on('change','.sticky-bar-product-options',function(){
    let _section = jQuery(this).closest('.shopify-section');
    let option = jQuery(this).attr('data-name');
    let value = jQuery(this).val();
    let mainOption = _section.find('.productOption[name="'+option+'"]');
    if(mainOption.is(':radio')){
      _section.find('.productOption[name="'+option+'"][value="'+value+'"]').attr('checked',true).trigger('click');
    }
    else{
      mainOption.val(value);
      let sectionId = document.querySelector('#'+_section.attr('id'))
      if(sectionId){
        let optionSelector = document.querySelector('.productOption[name="'+option+'"]');
        if(optionSelector){
          optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }    
  })
  if(fancySelector){
    Fancybox.bind(fancySelector, {
      touch: false,
      thumbs : {
        autoStart : true
      },
      on: {
        load: (fancybox, slide) => {
          document.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
          });
          document.querySelectorAll('.yv-youtube-video').forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
          });
          document.querySelectorAll('video').forEach((video) => video.pause());
          var fancyBoxContainer = $('body').find('.fancybox__container');
        },
        done: (fancybox, slide) => {
          var fancyBoxContainer = $('body').find('.fancybox__container');
        }
      },
      Toolbar: {
        display: [
          "close",
        ],
      }
    });
  }

  function playVideo() {
    currentVideo = $('[data-reel-content] video')[0];
    if (currentVideo) {
      currentVideo.load();
      currentVideo.play();
    }
  }

  function pauseVideo() {
    if (currentVideo) {
      currentVideo.pause();
    }
  }
})

class BadgeBuilder {
  constructor(canvasId, options = {}) {
    this.canvas = document.getElementById(canvasId);
    if (!this.canvas) return;

    this.ctx = this.canvas.getContext("2d");
    this.originalWidth = 790;
    this.originalHeight = 790;
    this.backgroundImage = new Image();
    this.options = {
      nameFontSize: 24,
      titleFontSize: 16,
      namePosition: { x: 0.26, y: 0.54 },
      titlePosition: { x: 0.26, y: 0.567 },
      fontFamily: "ArchivoNarrow",
      ...options,
    };

    // Get the background image URL from data attribute
    const imageUrl = this.canvas.dataset.image;
    if (imageUrl) {
      this.setBackground(imageUrl);
    }
    this.title = this.canvas.dataset.title;
    this.setupCanvas();
    this.redrawWhenFontReady();
  }

  setupCanvas() {
    // Handle window resize
    window.addEventListener("resize", () => this.resize());

    // Initial setup
    this.resize();
  }

  // Canvas text resolves whichever font is registered at the moment fillText
  // runs, and unlike DOM text it does not repaint itself when a webfont
  // arrives later. If ArchivoNarrow is still downloading during the first
  // draw, the badge silently renders in the fallback font and stays that way
  // until a resize or a form edit happens to trigger another draw. Redrawing
  // once the font resolves closes that window without delaying the first
  // paint: the initial draw still happens immediately, it is just corrected
  // afterwards if it needed correcting.
  redrawWhenFontReady() {
    if (!document.fonts || !document.fonts.load) return;
    const size = this.options.titleFontSize;
    document.fonts
      .load(`${size}px ${this.options.fontFamily}`)
      .then(() => this.draw())
      .catch(() => {});
  }

  resize() {
    // Get the container width
    const container = this.canvas.parentElement;
    const containerWidth = container.clientWidth;

    // Get the device pixel ratio
    const dpr = window.devicePixelRatio || 1;

    // Calculate scale
    this.scale = containerWidth / this.originalWidth;

    // Set display size
    this.canvas.style.width = containerWidth + "px";
    this.canvas.style.height =
      containerWidth * (this.originalHeight / this.originalWidth) + "px";

    // Set actual pixel size scaled for high DPI displays
    this.canvas.width = this.originalWidth * dpr;
    this.canvas.height = this.originalHeight * dpr;

    // Scale the context to ensure correct drawing operations
    this.ctx.scale(dpr, dpr);

    // Enable image smoothing
    this.ctx.imageSmoothingEnabled = true;
    this.ctx.imageSmoothingQuality = "high";

    // Redraw everything
    this.draw();
  }

  setBackground(imageUrl) {
    return new Promise((resolve, reject) => {
      this.backgroundImage.onload = () => {
        this.draw();
        resolve();
      };
      this.backgroundImage.onerror = reject;
      this.backgroundImage.src = imageUrl;
    });
  }

  updateText(name, title) {
    this.name = name;
    this.title = title;
    this.draw();
  }

  draw() {
    // Clear canvas with proper scaling
    this.ctx.clearRect(
      0,
      0,
      this.canvas.width / (window.devicePixelRatio || 1),
      this.canvas.height / (window.devicePixelRatio || 1)
    );

    // Draw background if loaded
    if (
      this.backgroundImage.complete &&
      this.backgroundImage.naturalWidth !== 0
    ) {
      this.ctx.drawImage(
        this.backgroundImage,
        0,
        0,
        this.originalWidth,
        this.originalHeight
      );
    }

    // Set up text styling
    this.ctx.textAlign = "left";
    this.ctx.fillStyle = "#000054";

    // Draw name
    if (this.name) {
      this.ctx.font = `500 ${this.options.nameFontSize}px ${this.options.fontFamily}`;
      this.ctx.fillText(
        this.name,
        this.originalWidth * this.options.namePosition.x,
        this.originalHeight * this.options.namePosition.y
      );
    }

    // Draw title
    if (this.title) {
      this.ctx.font = `${this.options.titleFontSize}px ${this.options.fontFamily}`;
      this.ctx.fillText(
        this.title,
        this.originalWidth * this.options.titlePosition.x,
        this.originalHeight * this.options.titlePosition.y
      );
    }
  }
}

class BadgeBuilderForm extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = `
          <section class="yv-badge-builder-form">
              <span style="margin-bottom:5px; font-weight:600;" class="yv-variant-title">Please enter the name you require on your badge</span>
              <div class="form-group">
                  <label for="ContactForm-username">Name</label>
                  <input type="text" class="form-control" id="ContactForm-username" name="properties[Name]" placeholder="Name" required="" aria-describedby="ContactForm-username-error">
                  <div id="ContactForm-username-error" class="yv-badge-builder-error" role="alert" style="display:none; color:#dc3545; margin-top:5px;"></div>
              </div>
          </section>
      `;

    this.nameInput = this.querySelector("#ContactForm-username");
    this.nameError = this.querySelector("#ContactForm-username-error");
    this.handleAddToCartClick = this.handleAddToCartClick.bind(this);
    this.nameBadgeFrame = document.querySelector(".badge-builder");
    this.images = document.querySelectorAll(".image-wrapper");

    // Initialize the badge builder
    this.badgeBuilder = null;
  }

  connectedCallback() {
    const targetId = this.getAttribute("target-badge-id");

    // The name is mandatory, but the product form is novalidate and
    // cart-ajax.js adds to cart via AJAX, so the input's required attribute is
    // never enforced. Block the ATC click in the capture phase, before the
    // delegated cart-ajax.js handler or a native submit can run.
    document.addEventListener("click", this.handleAddToCartClick, true);
    this.nameInput.addEventListener("input", () => {
      if (this.nameInput.value.trim() !== "") this.hideNameError();
    });

    // Initialize the badge builder after DOM is loaded
    document.addEventListener("DOMContentLoaded", () => {
      this.badgeBuilder = new BadgeBuilder("badgeCanvas");
    });

    if (targetId) {
      this.nameInput.addEventListener("input", (e) => {
        const targetSpan = document.getElementById(targetId);
        const value = e.target.value.trim();

        // Update target span if it exists
        if (targetSpan) {
          targetSpan.textContent = value;
        }

        // Update canvas text
        if (this.badgeBuilder) {
          this.badgeBuilder.updateText(value, this.badgeBuilder.title);
        }

        // Handle visibility
        const hasText = value !== "";

        // Hide all images first
        this.images.forEach((img) => {
          img.style.display = "none";
        });

        // Show badge builder frame if there's text
        if (hasText && this.nameBadgeFrame) {
          this.nameBadgeFrame.style.display = "block";
          // Trigger a resize to ensure canvas is properly rendered
          if (this.badgeBuilder) {
            this.badgeBuilder.resize();
          }
        } else {
          // Show all images except badge builder if no text
          this.images.forEach((img) => {
            if (!img.classList.contains("badge-builder")) {
              img.style.display = "block";
            }
          });
        }
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleAddToCartClick, true);
  }

  handleAddToCartClick(e) {
    const button = e.target.closest(".Sd_addProduct");
    if (!button) return;
    // Only gate the ATC button belonging to this badge's product form. The
    // .form-drawer fallback covers a drawer teleported out of the <form>.
    const scope =
      button.form || button.closest("form") || button.closest(".form-drawer");
    if (!scope || !scope.contains(this)) return;
    if (this.nameInput.value.trim() !== "") return;

    e.preventDefault();
    e.stopImmediatePropagation();
    this.showNameError();
  }

  showNameError() {
    this.nameError.textContent = "Please enter the name you require on your badge.";
    this.nameError.style.display = "block";
    this.nameInput.setAttribute("aria-invalid", "true");
    this.nameInput.focus();
  }

  hideNameError() {
    this.nameError.textContent = "";
    this.nameError.style.display = "none";
    this.nameInput.removeAttribute("aria-invalid");
  }
}

customElements.define("badge-builder-form", BadgeBuilderForm);
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.addToCartButton = document.querySelector('.Sd_addProduct');
    this.formInputs = this.querySelectorAll('input[required]');
    this.buttonContainer = document.querySelector('.pdp-action-container');
    this.validateForm = this.validateForm.bind(this);
    this.init();
  }

  init() {
    // Create clickable overlay
    this.clickOverlay = document.createElement('div');
    this.clickOverlay.style.position = 'absolute';
    this.clickOverlay.style.top = '0';
    this.clickOverlay.style.left = '0';
    this.clickOverlay.style.width = '100%';
    this.clickOverlay.style.height = '100%';
    this.clickOverlay.style.cursor = 'pointer';
    this.clickOverlay.style.display = 'none';
    this.clickOverlay.style.zIndex = '10';
    this.buttonContainer.appendChild(this.clickOverlay);

    // Create error message container
    this.errorContainer = document.createElement('div');
    this.errorContainer.style.display = 'none';
    this.errorContainer.className = 'form-error-message';
    this.buttonContainer.appendChild(this.errorContainer);

    this.setupEventListeners();
    this.validateForm(); // Initial validation
  }

  setupEventListeners() {
    // Add input validation events
    this.formInputs.forEach(input => {
      input.addEventListener('input', this.validateForm);
      input.addEventListener('change', this.validateForm);
      input.addEventListener('focus', () => this.hideErrorMessage());
    });

    // Handle overlay clicks
    this.clickOverlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.showErrorMessage();
      this.highlightMissingFields();
    });

    // Handle form submission
    const form = this.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!this.validateForm()) {
          e.preventDefault();
          this.showErrorMessage();
          this.highlightMissingFields();
        }
      });
    }
  }

  validateForm() {
    // Defer to SharedFormLogic if it's a lazy form
    if (this.hasAttribute('data-lazy-form')) return true;

    let isValid = true;
    this.missingFields = [];

    // Check each required input
    this.formInputs.forEach(input => {
      input.classList.remove('invalid');
      const label = document.querySelector(`label[for="${input.id}"]`);
      const fieldName = label ? label.textContent : input.name;

      let fieldValid = true;
      switch(input.type) {
        case 'email':
          fieldValid = this.validateEmail(input.value);
          break;
        case 'number':
          fieldValid = this.validateNumber(input.value);
          break;
        default:
          fieldValid = input.value.trim() !== '';
      }

      if (!fieldValid) {
        isValid = false;
        this.missingFields.push({
          name: fieldName,
          type: input.type
        });
      }
    });

    // Update UI states — only gate via overlay, never touch disabled.
    // Stock state (disabled/enabled) is owned by common.js + Liquid.
    this.clickOverlay.style.display = isValid ? 'none' : 'block';
    
    if (isValid) {
      this.hideErrorMessage();
    }

    return isValid;
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase());
  }

  validateNumber(value) {
    return !isNaN(value) && value.trim() !== '';
  }

  showErrorMessage() {
    if (!this.missingFields.length) return;

    const messages = this.missingFields.map(field => {
      let message = field.name;
      if (field.type === 'email') message += ' (valid email required)';
      if (field.type === 'number') message += ' (number required)';
      return `<li>${message}</li>`;
    });

    this.errorContainer.innerHTML = `
      <div style="color: #dc3545; margin: 10px 0;">
        <p>Please complete the following required fields:</p>
        <ul style="margin: 5px 0; padding-left: 20px;">
          ${messages.join('')}
        </ul>
      </div>
    `;
    this.errorContainer.style.display = 'block';

    // Scroll into view if needed
    if (!this.isInViewport(this.errorContainer)) {
      this.errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  hideErrorMessage() {
    this.errorContainer.style.display = 'none';
    this.formInputs.forEach(input => input.classList.remove('invalid'));
  }

  highlightMissingFields() {
    this.formInputs.forEach(input => {
      let isValid = true;
      switch(input.type) {
        case 'email':
          isValid = this.validateEmail(input.value);
          break;
        case 'number':
          isValid = this.validateNumber(input.value);
          break;
        default:
          isValid = input.value.trim() !== '';
      }

      if (!isValid) {
        input.classList.add('invalid');
        this.addShakeAnimation(input);
      }
    });
  }

  addShakeAnimation(element) {
    element.classList.add('shake');
    element.addEventListener('animationend', () => {
      element.classList.remove('shake');
    }, { once: true });
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}

// Add required styles
const styles = document.createElement('style');
styles.textContent = `
  .yv-checkout-btn{
    position:relative;
  }
  .form-control.invalid {
    border-color: #dc3545 !important;
    background-color: #fff8f8 !important;
  }

  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-10px); }
    75% { transform: translateX(10px); }
  }

  .shake {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  }

  .form-error-message {
    margin-top: 10px;
    padding: 10px;
    border: 1px solid #dc3545;
    border-radius: 4px;
    background-color: #fff8f8;
  }
`;
document.head.appendChild(styles);

// Register the custom element
customElements.define('product-form', ProductForm);